"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var shortid_1 = __importDefault(require("shortid"));
var context_1 = require("../../context");
var ActionBar_1 = require("../ActionBar");
var Align_1 = __importDefault(require("../Align"));
var Card_1 = require("../Card");
var Form_1 = __importDefault(require("../Form"));
var FormProvider_1 = __importDefault(require("../FormProvider"));
var Tabs_1 = require("../Tabs");
var ClientFormBody_1 = __importDefault(require("./ClientFormBody"));
var ClientFormInfo_1 = __importDefault(require("./ClientFormInfo"));
var defaultClientTabs_1 = __importDefault(require("./utils/defaultClientTabs"));
function ClientForm(props) {
    var children = props.children, cancelAction = props.cancelAction, hideInfo = props.hideInfo, onTabChange = props.onTabChange, client = props.client, tabs = props.tabs, onSubmit = props.onSubmit, errors = props.errors;
    var trans = context_1.useSemantics().trans;
    var _a = react_1.useState([]), combinedTabs = _a[0], setCombinedTabs = _a[1];
    react_1.useEffect(function () { return setCombinedTabs(tabs || defaultClientTabs_1.default(trans)); }, [tabs]);
    var clientFormId = react_1.useMemo(function () { return "client-form-" + shortid_1.default(); }, []);
    return (react_1.default.createElement(Tabs_1.Tabs, { tabs: combinedTabs, onChange: onTabChange },
        react_1.default.createElement(ActionBar_1.ActionBarBumper, null,
            react_1.default.createElement(Align_1.default, null,
                react_1.default.createElement("div", { className: "w-2/3" },
                    react_1.default.createElement(Align_1.default, { className: "w-full" },
                        react_1.default.createElement("div", { className: "w-64 flex-none" },
                            react_1.default.createElement(Card_1.Card, { size: Card_1.CardSize.FLUSH },
                                react_1.default.createElement("div", { className: "py-8 px-4" },
                                    react_1.default.createElement(Tabs_1.TabList, null)))),
                        react_1.default.createElement("div", { className: "px-6 flex-grow" },
                            react_1.default.createElement(FormProvider_1.default, { initialValues: client, initialErrors: errors, onSubmit: onSubmit, validateOnChange: false, validateOnBlur: false }, function (form) { return (react_1.default.createElement(Form_1.default, { id: clientFormId, "data-dusk": "client-form" },
                                react_1.default.createElement(ClientFormBody_1.default, null, children),
                                react_1.default.createElement(ActionBar_1.ActionBar, { primary: {
                                        processing: form.isSubmitting,
                                        label: trans('optiiva::labels.save-and-complete'),
                                        form: clientFormId,
                                    }, cancel: cancelAction
                                        ? {
                                            label: trans('optiiva::labels.cancel'),
                                            action: cancelAction,
                                        }
                                        : undefined }))); })))),
                react_1.default.createElement("div", { className: "w-1/3" }, !hideInfo && react_1.default.createElement(ClientFormInfo_1.default, { client: client }))))));
}
exports.default = ClientForm;
//# sourceMappingURL=ClientForm.js.map